import React from 'react';
import styled from 'styled-components/macro';
import Colors from '../internal-components/Colors';
import { SimpleFlexContainer } from './layouts/ng-layouts/Containers';

export const VARIANTS = {
  STANDARD: 's',
  MEDIUM: 'm'
};

const Label = styled.label`
  ${({ $variant }) => {
    if ($variant === VARIANTS.STANDARD) {
      return `font-size: 12px;`;
    }

    if ($variant === VARIANTS.MEDIUM) {
      return `font-size: 14px; font-weight: 500;`;
    }
  }}


  ${({ $asterisk }) =>
    $asterisk &&
    `&:after {
    content: ' *';
    color: ${Colors.OT_RED};
    font-size: 20px;
  }`}

  ${({ $customCSS }) => $customCSS}
`;

const Labeler = ({
  label = '',
  variant = VARIANTS.STANDARD,
  addAsterisk,
  customCSS = '',
  ...props
}) => {
  return (
    <SimpleFlexContainer>
      <Label $variant={variant} $customCSS={customCSS} $asterisk={addAsterisk}>
        {label}
      </Label>
      {props.children}
    </SimpleFlexContainer>
  );
};

export default Labeler;
